import { useCallback } from 'react';

import { trackGiftArticleLinkClick } from '../../biEvents';
import { LinkTitle } from '../components/LinkTitle';
import { ArrowIcon } from '../components/ArrowIcon';
import { GiftIcon } from '../components/GiftIcon';

type PropsT = {
  availableGiftTotal: number;
  goToGenerateLinkView: () => void;
  isMpArticle?: boolean;
};

export const GenerateGiftItem: React.FunctionComponent<PropsT> = ({
  availableGiftTotal,
  goToGenerateLinkView,
  isMpArticle,
}) => {
  const isDisabled = isMpArticle || availableGiftTotal === 0;

  const handleClick = useCallback(() => {
    trackGiftArticleLinkClick(availableGiftTotal);
    goToGenerateLinkView();
  }, [availableGiftTotal, goToGenerateLinkView]);

  return (
    <button
      aria-label="generate-link"
      className="flex w-full items-center justify-between disabled:cursor-default"
      data-test-id="gift-full-article-button"
      disabled={isDisabled}
      type="button"
      onClick={handleClick}
    >
      <div className="flex items-center">
        <GiftIcon isDisabled={isDisabled} />

        <LinkTitle
          availableCountText={`(${availableGiftTotal} remaining)`}
          isDisabled={isDisabled}
          subTitle="The recipient can read the entire article with no paywall"
          title="Gift full article"
        />
      </div>

      {isDisabled ? null : <ArrowIcon />}
    </button>
  );
};
